import type { ApiModuleEndpoints } from '../types'

export const areaPricingApiEndpoints = {
  list: {
    method: 'GET',
    path: '/area-pricing-policies',
    requiresAuth: true,
  },
  options: {
    method: 'GET',
    path: '/area-pricing-policies/options',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/area-pricing-policies/:id',
    requiresAuth: true,
  },
  create: {
    method: 'POST',
    path: '/area-pricing-policies',
    requiresAuth: true,
  },
  update: {
    method: 'PUT',
    path: '/area-pricing-policies/:id',
    requiresAuth: true,
  },
  delete: {
    method: 'DELETE',
    path: '/area-pricing-policies/:id',
    requiresAuth: true,
  },
  rules: {
    method: 'GET',
    path: '/area-pricing-policies/:id/rules',
    requiresAuth: true,
  },
  createRule: {
    method: 'POST',
    path: '/area-pricing-policies/:id/rules',
    requiresAuth: true,
  },
  updateRule: {
    method: 'PUT',
    path: '/area-pricing-rules/:id',
    requiresAuth: true,
  },
  deleteRule: {
    method: 'DELETE',
    path: '/area-pricing-rules/:id',
    requiresAuth: true,
  },
  preview: {
    method: 'POST',
    path: '/area-pricing/preview',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
